import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileAttachmentTray } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-attachments/FileAttachmentTray.js';
import { FileAttachmentKeyboardShortcut } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-attachments/internal/components/FileAttachmentKeyboardShortcut.js';
import { FileAttachmentMenuItem } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-attachments/internal/components/FileAttachmentMenuItem.js';
import { countFileDropItems } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-upload/dropFiles.js';
import { renderFileDropOverlay } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-upload/FileDropOverlaySupport.js';
import { getPastedTextFileName } from '#pplx/frontend/apps/ask/hooks/file-attachments-hooks/getPastedTextFileName.js';
import { ACCEPTED_FILE_TYPES_ALL } from '#pplx/frontend/components/utils/consts.js';
import { createFileAttachmentsPluginFactory } from '#pplx/frontend/composer-sdk-plugins/file-attachments/index.js';
import { useMemo } from 'react';
const fileAttachmentsPluginFactory = createFileAttachmentsPluginFactory();
export function useFileAttachmentPlugin({ uploadsEnabled, attachmentActionsEnabled, showFileMetadata, presentation, errorMessage, files, gateUploadFile, onDismissError, onDropItems, onFilesSelected, onOversizedTextPasted, onPreviewAttachment, onRemoveFile, oversizedText, uploadedAttachmentCount, renderAttachmentNotice, uploadPolicy, }) {
    return useMemo(() => {
        return fileAttachmentsPluginFactory({
            acceptedFileTypes: uploadPolicy.constraints.acceptedFileTypes ?? ACCEPTED_FILE_TYPES_ALL,
            attachmentTrayProps: {
                showFileMetadata,
                presentation,
                disabled: !attachmentActionsEnabled,
                errorMessage,
                files: files.map((file) => ({
                    ...file,
                    disabled: !attachmentActionsEnabled ||
                        (file.status !== 'success' && file.status !== 'failed') ||
                        file.previewTarget === undefined,
                })),
                onDismissError,
                onPreviewAttachment,
                onRemoveFile,
            },
            disabled: !uploadsEnabled,
            hasContent: files.length > 0,
            onDropItems,
            onFilesSelected,
            oversizedText,
            onPaste: (pastedFiles, context) => {
                const convertedFile = context?.oversizedTextFile;
                if (convertedFile === undefined) {
                    onFilesSelected(pastedFiles, 'paste');
                    return;
                }
                const fileName = getPastedTextFileName(uploadedAttachmentCount);
                const uploadFile = convertedFile.name === fileName
                    ? convertedFile
                    : new File([convertedFile], fileName, {
                        type: convertedFile.type,
                        lastModified: convertedFile.lastModified,
                    });
                onOversizedTextPasted?.(uploadFile);
                onFilesSelected(pastedFiles.map((file) => (file === convertedFile ? uploadFile : file)), 'paste');
            },
            renderAddFilesMenuItem: ({ closeMenu }) => (_jsx(FileAttachmentMenuItem, { closeMenu: closeMenu, disabled: !uploadsEnabled, canUploadFile: uploadPolicy.gate.canUploadFile, gateUploadFile: gateUploadFile, menuMessage: uploadPolicy.menuMessage, retentionDays: uploadPolicy.retentionDays })),
            renderAttachmentTray: (props) => (_jsxs(_Fragment, { children: [uploadsEnabled && _jsx(FileAttachmentKeyboardShortcut, { gateUploadFile: gateUploadFile }), renderAttachmentNotice?.(props), _jsx(FileAttachmentTray, { ...props })] })),
            renderDropOverlay: (state) => renderFileDropOverlay({ maxFiles: uploadPolicy.constraints.maxFiles }, state),
            validateDropItems: (items) => countFileDropItems(items) <= uploadPolicy.constraints.maxFiles - files.length,
        });
    }, [
        uploadsEnabled,
        attachmentActionsEnabled,
        errorMessage,
        files,
        showFileMetadata,
        presentation,
        gateUploadFile,
        onDismissError,
        onDropItems,
        onFilesSelected,
        onOversizedTextPasted,
        onPreviewAttachment,
        onRemoveFile,
        oversizedText,
        uploadedAttachmentCount,
        renderAttachmentNotice,
        uploadPolicy,
    ]);
}
//# sourceMappingURL=useFileAttachmentPlugin.js.map